/**
 * 質問リストをlist_order（表示順）昇順にソートする
 * @param {Array|null|undefined} questions - 質問オブジェクトの配列
 * @returns {Array} ソート済みの質問配列。questionsがnull/undefinedの場合は空配列
 */
export const sortQuestionsByListOrder = (questions) => {
  if (!questions) {
    return [];
  }
  return questions
    .map((question, index) => [question, index])
    .sort(([aQuestion, aIndex], [bQuestion, bIndex]) => {
      const isInvalidAListOrder =
        aQuestion.list_order == null || aQuestion.list_order < 1;
      const isInvalidBListOrder =
        bQuestion.list_order == null || bQuestion.list_order < 1;
      if (isInvalidAListOrder && isInvalidBListOrder) {
        return aIndex - bIndex;
      }
      if (isInvalidAListOrder) {
        return 1;
      }
      if (isInvalidBListOrder) {
        return -1;
      }
      return aQuestion.list_order - bQuestion.list_order;
    })
    .map(([question]) => question);
};
